const notificationtemplates = {
	title: "Notification Templates",
	new_notificationtemplate: "New Notification Template",
	edit_notificationtemplate: "Edit Template: {name}",
	view_notificationtemplate: "View Template: {name}",
	list_title: "List of Notification Templates",
	create_title: "Create Notification Template",
	update_title: "Update Notification Template",
	id: "ID",
	coursetemplate_id: "Course Template",
	slug: "Slug",
	subject: "Subject",
	template: "Template",
	description: "Short description",
	trigger: "Trigger",
	type: "Type",
	update_existing: "Update existing",
	update_existing_confirm: "Do you want to update all existing course templates with this email template?",
	available_tags: "Available tags",
	status: "Status",
	select_template: "Select template",
	message: "Message",
	email_notification: "Email notification",
	sms_notification: "SMS notification",
	notification_sent_successfully: "Notification(s) successfully sent",
	notification_sent_failed: "Failed to send notification(s)",
	cc_me: "Copy to me",
	bcc_me: "BCC to me",
};
export default notificationtemplates;